var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseWhite = function SvgCloseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    className: "icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m540.396 511.877 477.745-477.745a19.995 19.995 0 0 0-28.273-28.273L512.123 483.604 34.378 5.859A19.995 19.995 0 0 0 6.105 34.132L483.85 511.877 6.105 989.622a19.995 19.995 0 1 0 28.273 28.273L512.123 540.15l477.745 477.745a19.995 19.995 0 0 0 28.273-28.273z"
  })));
};
export { SvgCloseWhite as ReactComponent };
export default "/_next/static/images/close-white.svg";